import { useSelector } from 'react-redux'

import { BackArrow } from 'app/containers/widget/launcher/components'
import { Avatar } from 'app/components'
import { LAUNCHER_CONTENT_STATE } from 'app/constants/launcherContentStates'
import CloseWidgetBtn from 'app/components/CloseWidgetBtn'
import AiBotIcon from 'app/components/icons/AiBot'
import './header.scss'

const getLauncherInfo = ({ widgetData }) => widgetData.widgetInfo.launcherInfo

const Header = ({ showBackArrow, title, subTitle, avatar, acceptedByBot }) => {
  const launcherInfo = useSelector(getLauncherInfo)

  const customCssVariables = {
    '--raychat-header-title-text-color': 'var(--tertiary-color)',
    '--raychat-accepted-chat-header-bg':
      launcherInfo.content === LAUNCHER_CONTENT_STATE.MAIN_COVER ? 'none' : 'var(--primary-color)',
    '--raychat-accepted-chat-header-wp':
      launcherInfo.content === LAUNCHER_CONTENT_STATE.MAIN_COVER ? 'none' : 'var(--widget-wallpaper)',
  }

  // TODO: only use Avatar component and pass bot icon or a property
  const renderAvatar = () => {
    if (acceptedByBot) {
      return (
        <div className="ai_bot_avatar">
          <AiBotIcon pureSvg={true} />
        </div>
      )
    }

    return (
      <Avatar
        avatarInfo={{
          url: avatar,
          name: title,
        }}
        onlineBadge={true}
        backgroundSize={36}
        showTooltip={false}
      />
    )
  }

  return (
    <div className="accepted_chat_header_container_wrapper" style={customCssVariables}>
      <div id="accepted_chat_header" className="accepted_chat_header_container">
        <div className="accepted_chat_header">
          <div className="accepted_chat_operator_info">
            {renderAvatar()}
            <div className="accepted_chat_agent_info">
              <span className="accepted_chat_agent_name raychat-font-bold">{title}</span>
              <span className="accepted_chat_department_title">{subTitle}</span>
            </div>
          </div>
          <div className="accepted_chat_actions">
            <CloseWidgetBtn />
            {showBackArrow && <BackArrow />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Header
